//CodeCopy.vue
<template>
    <div class="copy-content">
        {{ title || '' }}
        <div class="code-copy-copy-btn iconfont" title="复制代码" @click="copyMessage(code);"
            :style="{ 'pointer-events': success ? 'none' : 'all' }" v-html="success ? '&#xe847;' : '&#xe766;'"></div>
        <span v-if="success" style="position: relative;float: right;padding: 0 10px;">copied!</span>
    </div>
</template>

<script>
import clipboard from "clipboard";
import { copyTxt } from "@/utils/myutils";
export default {
    data() {
        return {
            title: null,
            code: null,
            success: false,
        };
    },
    methods: {
        copyMessage(value) {
            copyTxt(value);
            this.success = true;
            setTimeout(() => {
                this.success = false;
            }, 1000);
        },
    },
};
</script>

<style>
.copy-content {
    height: 40px;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    float: left;
    line-height: 40px;
    box-sizing: border-box;
    padding-left: 10px;
    background: #222;
    transition: .3s;
    color: rgba(255, 255, 255, .7);
}

.code-copy-copy-btn {
    height: 40px;
    width: 40px;
    position: relative;
    float: right;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: rgba(255, 255, 255, .7);
    cursor: pointer;
    transition: 0.3s;
    user-select: none;
    -webkit-user-drag: none;
}

.code-copy-copy-btn:hover {
    color: #FFF;
}

.copy-content:hover {
    color: #FFF !important;
}
</style>
